import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { AlertColor } from '@mui/material';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { SharedProps, SnackbarMessage, VariantType } from 'notistack';

const useStyles = makeStyles({ name: 'AlertContainer' })(() => ({
    root: { minWidth: '100%' },
}));

const variantToColor = (variant: VariantType): AlertColor | undefined => {
    switch (variant) {
        case 'default':
            return undefined;
        default:
            return variant;
    }
};

interface AlertContainerProps extends Pick<SharedProps, 'variant'> {
    title?: string;
    message: SnackbarMessage;
}

const AlertContainer = React.forwardRef<HTMLDivElement, AlertContainerProps>(({ title, message, variant }, ref) => {
    const color = variant ? variantToColor(variant) : 'success';
    const { classes } = useStyles();
    return (
        <div ref={ref} className={classes.root}>
            <Alert variant={'filled'} severity={color}>
                {title && <AlertTitle key={Date.now()}>{title}</AlertTitle>}
                {message}
            </Alert>
        </div>
    );
});
AlertContainer.displayName = 'AlertContainer';

export default AlertContainer;
